import { axiosInstance } from '../axiosInstance';

export const getDocumentUrl = async (
  bucket: string,
  key: string,
): Promise<{ url: string }> => {
  const response = await axiosInstance.get(`/s3/temporary-url`, {
    params: { bucket: bucket, key: key },
  });

  return response.data;
};
